import { createRequiredValidators } from "@xo/client-common";
import { Type6Date } from "./Type6Date";

export function createType6DateValidators() {
    return [
        ...createRequiredValidators<Type6Date>(["simpleField", "valueListField", "validatedField", "arrayField", "valueListArray", "validatedArrayField"]),
    ];
}
